var NewsCategories = [
    {
        label: "Orientation",
        value: "orientation"
    },
    {
        label: "Vie \xe9tudiante",
        value: "vie_etudiante"
    }, 
];
var NewsSousCategories = {
    orientation: [
        {
            label: "Universit\xe9",
            value: "universite"
        },
        {
            label: "Pr\xe9pa",
            value: "prepa"
        },
        {
            label: "BUT",
            value: "but"
        },
        {
            label: "BTS",
            value: "bts"
        },
        {
            label: "Ecoles",
            value: "ecoles"
        },
        {
            label: "Parcoursup",
            value: "parcoursup"
        },
        {
            label: "Examens",
            value: "examens"
        }, 
    ],
    vie_etudiante: [
        {
            label: "Aides et conseils",
            value: "aides_et_conseils"
        },
        {
            label: "Emplois/stage/service civique/Alternance",
            value: "emplois_stage_servicecivique_Alternance"
        },
        {
            label: "Autres",
            value: "autres"
        }, 
    ]
};
export { NewsCategories, NewsSousCategories };
